import React from 'react';
import PropTypes from 'prop-types';
import ManagedInput from 'components/form/managed_input';

import classNames from 'classnames';

export default function ToggleOverrideSection({ checked, className, name, subtitle, title, onOverride, onRemove }) {
  return (
    <div className={classNames('mt-2 mb-4 override-section', { 'border-bottom pb-3': !checked }, className)}>
      <ManagedInput
        name={name}
        type="checkbox"
        value={checked}
        onValueChange={checked ? onOverride : onRemove}
      >
        <strong>{title}</strong>
      </ManagedInput>
      <div className="text-muted ml-4">
        { subtitle }
      </div>
    </div>
  );
}

ToggleOverrideSection.propTypes = {
  checked: PropTypes.bool.isRequired,
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  title: PropTypes.string.isRequired,
  onOverride: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired
};
